import React, { useState, useEffect, useRef } from "react";
import "../App.css";
import { useLocation, useHistory } from "react-router-dom";
import { Form, FormGroup, Button, Label, Input } from "reactstrap";
import Api from "./api/api";
import MyLoader from "./util/loader";
import showToast from "./util/toast";
import { ToastContainer } from "react-toastify";

const AddCategory = () => {
  const history = useHistory();
  const location = useLocation();
  let model = location.state.model;
  let editMode = model.title ? true : false;
  let parent = location.state.parent;
  let library_type = location.state.type;

  console.log("library_type: " + library_type);

  const [title, setTitle] = useState("");
  const [detail, setDetail] = useState("");
  const [mainShot, setMainShot] = useState(null);
  const [mainShotUrl, setMainShotUrl] = useState(null);
  const [mainShotName, setMainShotName] = useState(null);
  const [loader, setLoader] = useState(false);
  const addMainShot = useRef(null);
  const [ages, setAges] = useState([]);
  const [goals, setGoals] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [age, setAge] = useState("0"); // id
  const [goal, setGoal] = useState("0"); // id
  const [status, setStatus] = useState("0"); // id

  useEffect(() => {
    loadLocalData();
    loadData();
  }, []);

  useEffect(() => {
    console.log("useEffect filters");
  }, [age, goal, status]);

  const loadLocalData = () => {
    if (editMode) {
      setTitle(model.title);
      setDetail(model.detail);
      setMainShotUrl(model.image);
      setAge(model.age);
      setGoal(model.goal);
      setStatus(model.status);
    }
  };

  const loadData = () => {
    // load filters
    Api.getFilters(
      (response) => {
        setAges(response.ages);
        setGoals(response.goals);
        setStatuses(response.status);
      },
      (error) => {}
    );
  };

  const saveCategory = () => {
    if (mainShot == null || title === "") {
      return;
    }
    let parent_id = parent == null ? "0" : parent.id;
    setLoader(true);
    Api.addCategory(
      library_type,
      parent_id,
      title,
      detail,
      age,
      goal,
      status,
      mainShot,
      (response) => {
        setLoader(false);
        console.log("response", response);
        if (response.status === "success") {
          showToast("success", "Category added!");
          setTitle("");
          setMainShot(null);
          setMainShotUrl(null);
          setMainShotName(null);
          history.goBack();
        } else {
          showToast("error", "Failed!");
        }
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const updateCategory = () => {
    console.log("age: " + age);
    console.log("goal: " + goal);
    console.log("status: " + status);
    if (title === "") {
      return;
    }
    setLoader(true);
    Api.updateCategory(
      model.id,
      title,
      detail,
      age,
      goal,
      status,
      mainShot,
      (response) => {
        setLoader(false);
        if (response.status === "success") {
          showToast("success", "Category updated!");
        } else {
          showToast("error", "Failed!");
        }
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  return (
    <div className="main">
      <div
        className="titlebar"
        style={{ backgroundColor: "#f2f2f2", padding: 10, margin: -15 }}
      >
        <div style={{ color: "blue" }}>
          {editMode ? "Edit" : "Add"} Category
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginTop: 15,
        }}
      >
        <FormGroup>
          <Label style={{ marginTop: 15 }}>Choose Image</Label>
          <div style={{ marginRight: 0, marginBottom: 0 }}>
            <div
              onClick={() => {
                addMainShot.current.click();
              }}
              style={{
                width: 150,
                height: 150,
                backgroundColor: "gray",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <input
                type="file"
                style={{ display: "none" }}
                ref={addMainShot}
                onChange={(event) => {
                  setMainShot(event.target.files[0]);
                  setMainShotUrl(URL.createObjectURL(event.target.files[0]));
                  // setTitle(event.target.files[0].name.split('.')[0])
                }}
              />
              {mainShotUrl == null ? null : (
                <img
                  src={mainShotUrl}
                  style={{
                    position: "absolute",
                    width: 150,
                    height: 150,
                    objectFit: "cover",
                  }}
                />
              )}
            </div>
          </div>
          <div style={{ fontSize: 12, marginTop: 5 }}>
            {mainShot === null ? "" : mainShotName}
          </div>
        </FormGroup>
        <Form className="form" style={{ width: 500, marginTop: 20 }}>
          <FormGroup>
            <Input
              type="text"
              placeholder="Enter Category Name"
              value={title}
              onChange={(event) => {
                setTitle(event.target.value);
              }}
            />
          </FormGroup>
          <FormGroup style={{ marginTop: 10 }}>
            <Input
              type="textarea"
              placeholder="Enter Category Detail"
              value={detail}
              onChange={(event) => {
                setDetail(event.target.value);
              }}
            />
          </FormGroup>

          {library_type === "special" ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <FormGroup style={{ marginTop: 10 }}>
                <div>Age Range</div>
                <select
                  name="age"
                  id="age"
                  value={age}
                  style={{ alignSelf: "center", display: "flex", width: 200 }}
                  onChange={(event) => {
                    console.log("value: " + event.target.value);
                    setAge(event.target.value);
                  }}
                >
                  {ages.map((age, index) => {
                    return <option value={age.id}>{age.title}</option>;
                  })}
                </select>
              </FormGroup>
              <FormGroup style={{ marginTop: 10 }}>
                <div>Goal</div>
                <select
                  name="goal"
                  id="goal"
                  value={goal}
                  style={{ alignSelf: "center", display: "flex", width: 200 }}
                  onChange={(event) => {
                    setGoal(event.target.value);
                  }}
                >
                  {goals.map((goal, index) => {
                    return <option value={goal.id}>{goal.title}</option>;
                  })}
                </select>
              </FormGroup>
              <FormGroup style={{ marginTop: 10 }}>
                <div>Status</div>
                <select
                  name="status"
                  id="status"
                  value={status}
                  style={{ alignSelf: "center", display: "flex", width: 200 }}
                  onChange={(event) => {
                    setStatus(event.target.value);
                  }}
                >
                  {statuses.map((status, index) => {
                    return <option value={status.id}>{status.title}</option>;
                  })}
                </select>
              </FormGroup>
            </div>
          ) : null}

          <Button
            style={{ marginTop: 20, fontSize: 16 }}
            className="btn-block btn-dark"
            onClick={() => {
              if (!editMode) saveCategory();
              else updateCategory();
            }}
          >
            Save Category
          </Button>
        </Form>
      </div>
      <MyLoader loader={loader} />
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default AddCategory;
